import React from "react";
import { motion } from "framer-motion";
import { Check, Music, Video, DollarSign, BadgeCheck } from "lucide-react";

const SERVICES = [
  {
    Icon: Music,
    title: "توزیع موزیک",
    desc: "انتشار تک‌آهنگ، EP یا آلبوم در پلتفرم‌های بین‌المللی موسیقی.",
    features: [
      "انتشار در سرویس‌های جهانی",
      "ثبت اطلاعات هنرمند و اثر",
      "پشتیبانی در آماده‌سازی فایل و کاور",
      "مناسب برای خواننده‌ها، رپرها و تهیه‌کننده‌ها",
    ],
  },
  {
    Icon: Video,
    title: "توزیع موزیک‌ویدیو",
    desc: "انتشار و مدیریت موزیک‌ویدیو در پلتفرم‌های ویدیویی و موسیقی.",
    features: [
      "مناسب برای موزیک‌ویدیوهای رسمی",
      "امکان درآمدزایی از ویدیو",
      "مدیریت اطلاعات اثر",
      "پشتیبانی در فرآیند انتشار",
    ],
  },
  {
    Icon: DollarSign,
    title: "نقد کردن درآمد موسیقی",
    desc: "جمع‌آوری درآمد ارزی از پلتفرم‌ها و تسویه سهم هنرمند در ایران.",
    features: [
      "کارمزد شفاف ۲۵ درصد",
      "پرداخت سهم با بالاترین نرخ ارز قابل پرداخت",
      "گزارش درآمد",
      "مناسب برای هنرمندان فعال و لیبل‌ها",
    ],
  },
  {
    Icon: BadgeCheck,
    title: "دریافت حق مالکیت",
    desc: "ما برای آثار شما مجوزها و کدهای بین‌المللی UPC، ISRC و Content ID را دریافت می‌کنیم تا مالکیت رسمی شما تثبیت شود.",
    features: [
      "دریافت کد UPC برای آلبوم",
      "دریافت کد ISRC برای هر تک‌آهنگ",
      "ثبت Content ID در پلتفرم‌های ویدیویی",
      "تثبیت مالکیت رسمی اثر",
    ],
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <h2 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight">
            خدمات ما برای <span className="gradient-text-neon">هنرمندان و لیبل‌ها</span>
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="glass glass-hover rounded-3xl p-8 transition-all"
              data-testid={`service-card-${i}`}
            >
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-purple-500/30 to-cyan-400/30 border border-white/10 flex items-center justify-center mb-5">
                <s.Icon className="w-5 h-5 text-white" strokeWidth={1.7} />
              </div>
              <h3 className="text-xl font-bold mb-2">{s.title}</h3>
              <p className="text-sm text-slate-300 leading-relaxed mb-5">{s.desc}</p>
              <ul className="space-y-2.5">
                {s.features.map((f, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-slate-200">
                    <Check className="w-4 h-4 text-cyan-300 mt-0.5 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
